import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const RECENT_ITEMS_KEY = 'v8.recentMenuItems';
const MAX_RECENT = 5;

@Injectable({ providedIn: 'root' })
export class RecentMenuService {
	private recentItems$ = new BehaviorSubject<string[]>(this.loadRecentItems());

	get recentItems(): string[] {
		return this.recentItems$.getValue();
	}

	private loadRecentItems(): string[] {
		try {
			const stored = localStorage.getItem(RECENT_ITEMS_KEY);
			return stored ? JSON.parse(stored) : [];
		} catch {
			return [];
		}
	}

	private saveRecentItems(items: string[]): void {
		try {
			localStorage.setItem(RECENT_ITEMS_KEY, JSON.stringify(items));
		} catch {
			// ignore
		}
	}

	addRecent(id: string): void {
		const current = this.recentItems$.getValue();
		const filtered = current.filter(oid => oid !== id);
		const updated = [id, ...filtered].slice(0, MAX_RECENT);
		this.saveRecentItems(updated);
		this.recentItems$.next(updated);
	}

	subscribe(fn: (ids: string[]) => void): { unsubscribe: () => void } {
		const sub = this.recentItems$.subscribe(fn);
		return { unsubscribe: () => sub.unsubscribe() };
	}
}
